export const contentListToOmit = [
  null,
  'null',
  'null.',
  'null. ',
  undefined,
  'undefined',
  'undefined.',
  'undefined. ',
];
